import AutoCompleteInput from './AutoCompleteInput'

export default AutoCompleteInput
